import React from "react";

import Avatar from "@mui/material/Avatar";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import Divider from "@mui/material/Divider";
import Settings from "@mui/icons-material/Settings";
import Logout from "@mui/icons-material/Logout";
import { useAuthContext } from "../../../../context/authContext";
import AvatarComponent from "../AvatarComponent";
import { Box, ListSubheader, Typography } from "@mui/material";
import AdminOptions from "./AdminOptions";
import { capitalize } from "../../../../utils/Capitalize";

const sx = {
  minWidth: 200,
  overflow: "visible",
  filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
  mt: 1.5,
  px: 1,

  "&::before": {
    content: '""',
    display: "block",
    position: "absolute",
    top: 0,
    right: 19,
    width: 10,
    height: 10,
    bgcolor: "background.paper",
    transform: "translateY(-50%) rotate(45deg)",
    zIndex: 0,
  },
};

export default function UserMenu({ open, openUserMenu, setOpenUserMenu }) {
  const { user, askToLogout } = useAuthContext();

  const handleClose = () => {
    setOpenUserMenu(null);
  };

  return (
    <Menu
      anchorEl={openUserMenu}
      id="account-menu"
      open={open}
      onClose={handleClose}
      onClick={handleClose}
      slotProps={{
        paper: {
          elevation: 0,
          sx,
        },
      }}
      transformOrigin={{ horizontal: "right", vertical: "top" }}
      anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
    >
      <MenuItem>
        <AvatarComponent size={60} sx={{ mr: 1 }} />
        <Box>
          <Typography variant="h6" sx={{ fontWeight: "bold", color: "#444" }}>
            {user.name}({capitalize(user.role)})
          </Typography>
          <Typography variant="p">{user.email}</Typography>
        </Box>
      </MenuItem>

      {user?.role?.toLowerCase() === "admin" && (
        <AdminOptions handleClose={handleClose} />
      )}

      <Divider />

      <MenuItem onClick={handleClose}>
        <ListItemIcon>
          <Settings fontSize="small" />
        </ListItemIcon>
        Settings
      </MenuItem>
      <MenuItem onClick={askToLogout}>
        <ListItemIcon>
          <Logout fontSize="small" />
        </ListItemIcon>
        Sign out
      </MenuItem>
    </Menu>
  );
}
